import { callApi } from "@/api/callEndpoint";
import { appointmentEndpoints } from "@/api/contracts/appointments.contract";
import type { PendingBookingPayload } from "@/auth/authCoordinator";

export async function requestAppointment(
  input: PendingBookingPayload,
): Promise<string> {
  const res = await callApi<{ appointmentId: string }>(
    appointmentEndpoints.create,
    { data: input },
  );
  return res.appointmentId;
}
